// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3OFtZ","left":"styles_left__2ObqX"};